export const Lista_Experiencia_General = [
    'Ninguna',
    'Baja (menos de 1 año)',
    'Media (1-3 años)',
    'Alta (más de 3 años)'
] as const;